// @flow
import * as React from 'react';
import NumberFormat from 'react-number-format';
import styled from 'styled-components';
import Merchant from '../lib/Merchant';
import Container from './Container';
import ButtonIcon from './ButtonIcon';
import TextStrong from './TextStrong';

type TProps = {
  onChange: (value: string) => void,
  error?: ?string,
  mask?: ?string,
  merchant: Merchant,
};

const StyledInput = styled.input`
  height: 50px;
  padding-left: 16px;
  padding-right: 46px;
  font-family: InterSemiBold;
  font-size: 16px;
  width: 100%;
  border-color: ${props => props.error ? 'red' : '#000'};
  border-style: solid;
  border-width: 1px;
  border-radius: 2px;
  appearance: none;
  transition: 500ms ease-in-out;
  color: ${props => props.valid ? '#000' : '#777'};
`;

export default function InputCCAccountNumber(props: TProps): React.Node {
  const [isValid, setIsValid] = React.useState(false);

  const _onChange = (event) => {
    const cleanedValue = event.target.value.replace(/\s/g, '');
    props.onChange(cleanedValue);
    if (event.target.value.includes('*') && isValid) setIsValid(false);
    if (!event.target.value.includes('*') && !isValid && cleanedValue) setIsValid(true);
  };

  // Default format for credit cards
  let format = '####  ####  ####  ####';
  if (props.merchant.mch_id === 'mch_3') format = '####  ######  #####'; // Is amex
  if (props.mask) format = format.replace(/#{4}$/, props.mask);
  const placeholder = format.replace(/#/gi, '*');

  return (
    <Container>
      <Container flex centered fullwidth height="50px" relative>
        <NumberFormat
          customInput={StyledInput}
          valid={isValid}
          isNumericString={false}
          mask="*"
          format={format}
          placeholder={placeholder}
          autoComplete="cc-number"
          onChange={_onChange} />
        <Container flex centered absolute fullheight right={16} fill="white">
          <Container ml={12}><ButtonIcon name="shield-lock-fill" /></Container>
        </Container>
      </Container>
      {props.error && (
        <Container flex align="center" py={16} ml={2}>
          <Container mr={8}>
            <ButtonIcon name="exclamation-triangle" color="red" />
          </Container>
          <TextStrong>{props.error}</TextStrong>
        </Container>
      )}
    </Container>
  );
}
